import useAlertPromote from './useAlertPromote';
import GenericTaskList from '../GenericTaskList';

function AlertPromote() {
  const { items, handleAction, handleSkip } = useAlertPromote();

  if (items.length === 0) {
    return null;
  }

  return (
    <GenericTaskList
      items={items}
      onAction={handleAction}
      onSkip={handleSkip}
      variant="recommendations"
      paddingVertical="2"
    />
  );
}

export default AlertPromote;
